import type { SVGProps } from "react";
const SvgIconEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="m760.9 398.86 55.15-55.15c19.53-19.53 19.53-51.18 0-70.71L751 207.95c-19.53-19.53-51.18-19.53-70.71 0l-55.15 55.15zM589.78 298.45 285.49 602.74a50 50 0 0 0-12.94 22.41l-37.26 139.06c-3.98 14.87 9.62 28.48 24.49 24.49l139.06-37.26a49.9 49.9 0 0 0 22.41-12.94l304.29-304.29z" />
  </svg>
);
export default SvgIconEdit;
